// frontend/src/App.js


import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { PresentationPrivacyProvider } from './context/PresentationPrivacyContext';
import AppController from './components/AppController';
import './css/App.css';

function App() {
  return (
    <PresentationPrivacyProvider>
      <AuthProvider>
        <AppController />
      </AuthProvider>
    </PresentationPrivacyProvider>
  );
}

export default App;
